import { useRef } from 'react';

/**
 * Devuelve una referencia que mantiene siempre el último valor del elemento
 * pasado, es especialmente útil para acceder a valores del componente desde
 * dentro de efectos.
 *
 * *Investigar qué es 'react stale state'*
 */
export function useLatest<T>(value: T) {
  const ref = useRef(value);
  ref.current = value;
  return ref;
}
